import axios from "axios";
import store from "../store";
import state from "@/store";

const baseURL = store.getters.mainAppURL + "/";
const getVoidItems = (params) => axios.post(state.getters.mainAppURL + "void_items/all", params);
const getItemWiseSale = (params) => axios.post(store.getters.mainAppURL + "dashboard/get_item_wise_sale", params );
const getCategoryWiseSale = (params) => axios.post(store.getters.mainAppURL + "dashboard/get_category_wise_sale", params );

export {
    getVoidItems,
    getItemWiseSale,
    getCategoryWiseSale
}


